import React from 'react';
import { composeProvider } from 'react-compose-provider';
import { FiltersProvider } from '../hooks/use-filters';
import { SelectedStudentsProvider } from '../hooks/use-selected-students';
import { CourseEnrolleesProvider } from '../hooks/use-course-enrollees';
import { CandidatesCacheProvider } from '../hooks/use-candidates-cache';
import { StudentsProvider } from '../hooks/use-students';
import { GradYearVisibilityProvider } from '../hooks/use-grad-year-visibility';
import { GradYearSelectabilityProvider } from '../hooks/use-grad-year-selectability';

export const Providers = composeProvider(
    FiltersProvider,
    CandidatesCacheProvider,
    StudentsProvider,
    GradYearVisibilityProvider,
    SelectedStudentsProvider,
    GradYearSelectabilityProvider,
    CourseEnrolleesProvider,
);
